export default __webpack_public_path__ + "static/media/daylotts1000_icon.86f49858.svg";